function updateExternaLinks(selector) {
	var _externalLinks = document.querySelectorAll(selector);
	var _link = {},
		_text = '',
		_indicator = '<span class="nav-external-link"> Opens in new window</span><i class="icon-external-link"></i>';
	for (var i = 0; i < _externalLinks.length; i++) {
		_link = _externalLinks[i];
		_text = _link.innerHTML;

		_link.innerHTML = _text + _indicator;
	}
}
module.exports = updateExternaLinks;
